import React, { useState, useEffect } from 'react';
import { Box, Chip, Grid, Paper, Typography } from '@material-ui/core';
import { sanlamBlue } from 'Material-UI/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import axiosInstance from 'utils/axiosInstance';
import axios from 'axios';

import { useLayoutStyles, StyledWrapper, useStyles } from './styles';
import { ServerStatus } from './types';
import { initServers } from './constants';

const StatusPage = () => {
  const [servers, setServers] = useState<ServerStatus[]>(initServers);
  const classes = useStyles();
  const layoutClasses = useLayoutStyles();
  /* istanbul ignore next */
  const fetchStatusData = async (url: string) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return null;
    }
  };
  /* istanbul ignore next */
  const getStatusServers = async () => {
    const [
      healthCheckData,
      gatewayData,
      ecomData,
      myclientData,
    ] = await Promise.all([
      axiosInstance.get('/health-check'),
      fetchStatusData(`${process.env.REACT_APP_GATEWAY}/status`),
      fetchStatusData(`${process.env.REACT_APP_ECOMMERCE_API_URL}health-check`),
      fetchStatusData(`${process.env.REACT_APP_MYCLIENT_API_URL}/health`),
    ]);

    const filteredHealthCheckData = healthCheckData.data || [];
    const filteredGatewayData = gatewayData.data || [];
    const filteredEcomData = ecomData || [];
    const filteredMyClientData = myclientData ? [myclientData] : [];

    const combinedData = [
      ...filteredHealthCheckData,
      ...filteredGatewayData,
      ...filteredEcomData,
      ...filteredMyClientData,
    ];

    const filteredInitServers = initServers.filter((server) => {
      return !combinedData.some((data) => data.name === server.name);
    });

    const finalServers = [...combinedData, ...filteredInitServers];
    setServers(finalServers);
  };

  useEffect(() => {
    getStatusServers();

    const interval = setInterval(getStatusServers, 30000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <StyledWrapper>
      <Box className={layoutClasses.box} paddingY={2}>
        <Typography
          variant="h1"
          gutterBottom
          style={{
            textAlign: 'center',
            marginBottom: '80px',
            color: sanlamBlue[500],
          }}
        >
          Status Page
        </Typography>
        <Grid container spacing={3}>
          {servers.map((server, index) => (
            <Grid item xs={6} key={index}>
              <Paper className={classes.serverBox}>
                <div>
                  <Typography className={classes.boxTitle} variant="h5">
                    {server.name}
                  </Typography>
                  <Chip
                    label={server.status}
                    style={{
                      backgroundColor: server.color,
                      fontWeight: 'bold',
                      color: 'white',
                      marginTop: '10%',
                    }}
                  />
                </div>

                {server.status === 'En ligne' ? (
                  <CheckCircleIcon
                    style={{
                      color: server.color,
                    }}
                    fontSize="large"
                  />
                ) : (
                  <CancelIcon
                    style={{
                      color: server.color,
                    }}
                    fontSize="large"
                  />
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledWrapper>
  );
};

export default StatusPage;
